export const ALERT_DURATION = 5000;
export const QUESTION_CHAR_LIMIT = 150;
export const MCQ_QUESTION_CHAR_LIMIT = 200;
export const MCQ_ANSWER_CHAR_LIMIT = 60;
export const EXPLANATION_CHAR_LIMIT = 500;
export const ANSWER_CHAR_LIMIT = 60;
export const ERROR_TEXT_LIMIT = 100;
export const CONTENT_TITLE_CHAR_LIMIT = 40;
export const KNOW_MORE_CHAR_LIMIT = 10000;
export const MCQ_MIN_ITEMS_NUMBER = 2;
export const MCQ_ITEM_TITLE_CHAR_LIMIT = 60;
export const ORDERING_CARDS_MIN_ITEMS_NUMBER = 3;
export const ORDERING_CARDS_MAX_ITEMS_NUMBER = 10;
export const ORDERING_CARDS_QUESTION_CHAR_LIMIT = 60;
export const ORDERING_CARDS_LABEL_CHAR_LIMIT = 30;
export const ORDERING_CARDS_TITLE_CHAR_LIMIT = 90;
export const SWIPING_CARDS_ZONE_CHAR_LIMIT = 20;
export const SWIPING_CARDS_TITLE_CHAR_LIMIT = 60;
export const NO_INTERACTION_TEXT_CHAR_LIMIT = 10000;
export const NO_INTERACTION_TITlE_CHAR_LIMIT = 40;
export const PICTURE_SPOT_MAX_TABS = 3;
export const PICTURE_SPOT_DESCRIPTION_LIMIT = 60;
export const PICTURE_SPOT_BASE_POSITIONS = {
  x: 200,
  y: 300,
  r: 30,
};
